// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l4y3","left":"styles_left__2oCkD","desktopActions":"styles_desktopActions__1lmjt","title":"styles_title__5fJMN"};